import React from 'react';
import { CheckboxGroupField as CheckboxGroupFieldType } from '../../types/optionTypes';

interface CheckboxGroupFieldProps {
    field: CheckboxGroupFieldType;
    value: any[];
    onChange: (value: any[]) => void;
}

export const CheckboxGroupField: React.FC<CheckboxGroupFieldProps> = ({ field, value = [], onChange }) => {
    const handleChange = (optionValue: string, checked: boolean) => {
        if (checked) {
            onChange([...value, optionValue]);
        } else {
            onChange(value.filter(v => v !== optionValue));
        }
    };

    return (
        <div className="w-full">
            {field.label && (
                <label className="block text-sm font-medium text-gray-800 mb-2">
                    {field.label}
                    {field.required && <span className="text-red-500 ml-1">*</span>}
                </label>
            )}

            <div className="space-y-2.5 bg-gray-50 p-3 rounded-md border border-gray-200">
                {field.values.map((option) => (
                    <label key={option.tempId} className="flex items-start space-x-2.5 cursor-pointer group hover:bg-white p-1.5 rounded transition-colors">
                        <input
                            type="checkbox"
                            checked={value.includes(option.value)}
                            onChange={(e) => handleChange(option.value, e.target.checked)}
                            className="mt-0.5 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                        />
                        <span className="text-sm text-gray-700 leading-relaxed flex-1">{option.label}</span>
                    </label>
                ))}
            </div>

            {field.description && (
                <div className="mt-1.5 text-xs text-gray-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: field.description }} />
            )}
            {field.errorMessage && (
                <p className="text-xs text-red-500 mt-1">{field.errorMessage}</p>
            )}
        </div>
    );
};
